import { Autocomplete, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useGetCagePositionsByLocality } from 'src/api/positions'
import { AppTextField } from 'src/components/AppTextField'
import BasicDatePicker from 'src/components/DateTimePicker'
import { IPosition } from 'src/generated-types'
import { getMooringName, getPositionName } from 'src/utils/function'

export const SelectPlacement: React.FC<{
  customerId: EntityId
  localityId: EntityId
  disabled: boolean
  form: any
}> = ({ customerId, localityId, form, disabled }) => {
  const { data: cages } = useGetCagePositionsByLocality(customerId, localityId)
  const { t } = useTranslation(['service-station', 'common'])

  const selectedPositionId = form.watch('selectedPositionId')
  const selectedOption = (cages ?? []).find(c => c.id === selectedPositionId) ?? null
  const selectedPositionError = form.formState?.errors?.selectedPositionId?.message as string | undefined

  return (
    <>
      <Autocomplete
        value={selectedOption}
        onChange={(_, value) => {
          if (value) {
            const v = value as IPosition
            form.setValue('selectedPositionId', v.id, { shouldValidate: true })
            form.setValue('selectedMooringId', v.mooringId)
            form.clearErrors('selectedPositionId')
          } else {
            form.setValue('selectedPositionId', undefined, { shouldValidate: true })
            form.setValue('selectedMooringId', undefined)
          }
        }}
        onBlur={() => form.trigger('selectedPositionId')}
        disabled={disabled}
        groupBy={option => getMooringName(option.mooringName ?? '') ?? ''}
        options={(cages ?? []) as IPosition[]}
        autoHighlight
        getOptionLabel={o => getPositionName(o)}
        renderOption={(props, o) => (
          <MenuItem {...props} key={o.id} value={o.id}>
            {getPositionName(o)}
          </MenuItem>
        )}
        renderInput={params => (
          <AppTextField
            {...params}
            label={`${t('selectPlacement', { ns: 'main-component' })} (${t('optional', { ns: 'main-component' })})`}
            inputProps={{
              ...params.inputProps,
            }}
            error={!!selectedPositionError}
            helperText={selectedPositionError}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
      <BasicDatePicker
        label={`${t('installationDate', { ns: 'main-component' })} (${t('optional', { ns: 'main-component' })})`}
        name="installationDate"
        disabled={disabled}
      />
    </>
  )
}
